import React from 'react';
import { motion } from 'framer-motion';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
}
export function Card({
  children,
  className = '',
  hover = false
}: CardProps) {
  const baseStyles = 'bg-gray-900 border border-gray-800 rounded-xl overflow-hidden';
  const hoverStyles = hover ? 'transition-all duration-300 hover:border-green-500 hover:shadow-lg hover:shadow-green-500/20' : '';
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5
  }} className={`${baseStyles} ${hoverStyles} ${className}`} data-id="element-214">
      {children}
    </motion.div>;
}